import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-dividas-vencidas',
  templateUrl: './consulta-dividas-vencidas.component.html',
  styleUrls: ['./consulta-dividas-vencidas.component.scss']
})
export class ConsultaDividasVencidasComponent implements OnInit {

  title = "DÍVIDAS VENCIDAS";
  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {
    if(!this.consulta.registros || this.consulta.registros.length == 0) {
      this.codigoControle = "SEMREGISTRO_OK";
    }

    if(this.consulta.registros.length > 0) {
      this.status = 'danger';
    }

    if(this.codigoControle == "SEMREGISTRO_OK") {
      this.status = 'success';
    }
  }

}
